import { phoneFormatter } from "../../../../../shared/utils/phone-formatter";
import type { CaregiverEmergencyContact } from "./caregiverEmergencyContact.types";

export function createEmptyCaregiverEmergencyContact(): CaregiverEmergencyContact {
  return {
    address: "",
    livesWithPatient: null,
    name: "",
    phone1: "",
    phone2: "",
    relationship: "",
  };
}

export function mapCaregiverEmergencyContactToDraft(
  contact: Partial<CaregiverEmergencyContact> | null | undefined
): CaregiverEmergencyContact {
  return {
    address: contact?.address ?? "",
    livesWithPatient: contact?.livesWithPatient ?? null,
    name: contact?.name ?? "",
    phone1: contact?.phone1 ? phoneFormatter.formatNumberWithoutCountryPrefix(contact.phone1) : "",
    phone2: contact?.phone2 ? phoneFormatter.formatNumberWithoutCountryPrefix(contact.phone2) : "",
    relationship: contact?.relationship ?? "",
  };
}

export function normalizeCaregiverEmergencyContact(
  contact: Partial<CaregiverEmergencyContact> | null | undefined
): CaregiverEmergencyContact {
  const draft = mapCaregiverEmergencyContactToDraft(contact);
  const phone2 = draft.phone2.trim();

  return {
    address: draft.address.trim(),
    livesWithPatient: draft.livesWithPatient,
    name: draft.name.trim(),
    phone1: phoneFormatter.formatE164(draft.phone1),
    phone2: phone2 === "" ? "" : phoneFormatter.formatE164(phone2),
    relationship: draft.relationship.trim(),
  };
}

export function getCaregiverEmergencyContactsValidationMessage(
  contacts: CaregiverEmergencyContact[]
) {
  const messages = contacts.flatMap((contact, index) => {
    const draft = mapCaregiverEmergencyContactToDraft(contact);
    const phone1 = draft.phone1.trim();
    const phone2 = draft.phone2.trim();
    const contactNumber = index + 1;
    const contactMessages: string[] = [];

    if (draft.name.trim() === "") {
      contactMessages.push(`Missing or invalid emergency contact #${contactNumber}: name`);
    }

    if (phone1 === "" || !phoneFormatter.isValidNumber(phone1)) {
      contactMessages.push(`Missing or invalid emergency contact #${contactNumber}: phone #1`);
    }

    if (phone2 !== "" && !phoneFormatter.isValidNumber(phone2)) {
      contactMessages.push(`Invalid emergency contact #${contactNumber}: phone #2`);
    }

    return contactMessages;
  });

  if (messages.length === 0) {
    return null;
  }

  return messages;
}

export function formatCaregiverEmergencyContactPhone(value: string | null | undefined) {
  const phone = value ?? "";

  return phone.trim() === "" ? "" : phoneFormatter.formatNationalIfValid(phone);
}
